export default {
  computed: {
    detectLocale: function () {
      return window.navigator.languages
        ? window.navigator.languages[0]
        : window.navigator.userLanguage || window.navigator.language
    },
  },
}
